import { ascend, prop, sort } from 'ramda';

import { COMPANY } from 'constants/general';
import fetch from 'features/common/fetch';

import { actions } from './reducer';
import { getAgencies, getAgenciesForSidebar } from './selectors';

export const fetchAgencies =
	({ formName, channelId, regionId, type, onSuccess, customAllowedAgencies }) =>
	async (dispatch, getState, { getFormData }) => {
		const formData = await getFormData(formName);

		return dispatch(
			fetch.actions.get(fetch.constants.urls.orgStructureAgencies, {
				uniqueReqID: type ? type : null,
				queryParams: { channelId, regionId, companyId: COMPANY.CP },
				onSuccess: [
					(response) => () => {
						const byId = ascend(prop('id'));
						const sortedAgencies = sort(byId, response.body);
						dispatch(actions.appendData(sortedAgencies));

						const finalAgencies =
							type === 'sidebar'
								? getAgenciesForSidebar(getState(), formData, customAllowedAgencies)
								: getAgencies(getState(), formData);

						onSuccess(finalAgencies);
					},
				],
			}),
		);
	};

export const fetchAgenciesForCampaignRegionNominations =
	(channelId, regionId, companyId, fetchSuffix) => (dispatch) => {
		const defeaultCompanyId = COMPANY.CP;
		const reqCompanyId = companyId || defeaultCompanyId;

		return dispatch(
			fetch.actions.get(
				fetch.constants.urls.orgStructureAgencies,
				Object.assign(
					{},
					fetchSuffix ? { uniqueReqID: fetchSuffix } : null,
					{ queryParams: { channelId, regionId, companyId: reqCompanyId } },
					{
						onSuccess: [
							(response) => () => {
								const byId = ascend(prop('id'));
								const sortedAgencies = sort(byId, response.body);
								dispatch(actions.appendData(sortedAgencies));
							},
						],
					},
				),
			),
		);
	};
